// components/product/ProductGrid.js
import CustomerProductCard from './CustomerProductCard';
import AnimatedDiv from '../ui/AnimatedDiv';

const ProductGrid = ({ products }) => {
  if (!products || products.length === 0) {
    // This message is now less likely to be seen if pages/index.js handles empty arrays
    // but useful if ProductGrid is used elsewhere without pre-filtering
    return (
      <div className="text-center text-gray-500 dark:text-gray-400 py-10">
        No products found.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {products.map((product, index) => (
        <AnimatedDiv key={product._id || product.id} animation="fadeInUp" delay={index * 0.05} className="h-full">
          <CustomerProductCard product={product} />
        </AnimatedDiv>
      ))}
    </div>
  );
};

export default ProductGrid;